var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('StepHeader',{attrs:{"subtitle":_vm.subtitle,"description":_vm.description}}),_vm._v(" "),_c('StepBtnGroup',{staticClass:"mt-6 step-group media",attrs:{"fields":_vm.fields,"selectedValue":_vm.selectedMedia,"orientation":'column',"layout":"'full-width'"},on:{"select-value":_vm.selectMedia}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56b9c737","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myHabiteoStudio/steps/StepMedia.vue
// module id = null
// module chunks = 